<template>
  <div class="container" ref="cnt">
    <el-image class="shadow-down banner" :src="require('@/assets/announce_banner.jpg')"></el-image>
    <el-table :data="
        handleList
      " ref="announceTable" class="table">
      <el-table-column prop="title" label="标题" width="700px">
        <template slot-scope="scope">
          <!-- <router-link class="lk" v-bind:to="{
              name: 'notice_detail',
              params: {
                notice: scope.row.notic,
                title: scope.row.title,
                datum: scope.row.datum,
                zgglk: scope.row.zgglk,
              },
              query: {
                guid: scope.row.guid,
              },
            }">{{ scope.row.title }}</router-link> -->
            <router-link class="lk" v-bind:to="{
              name: 'notice_detail',
              query: {
                guid: scope.row.guid,
              },
            }">{{ scope.row.title }}</router-link>
        </template>
      </el-table-column>
      <el-table-column prop="datum" label="日期"></el-table-column>
    </el-table>
    <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" layout="prev, pager, next" :total="total" style="text-align: center"></el-pagination>
    <div ref="autoH" :style="{ height: autoHeight }"></div>
  </div>
</template>

<script>
import { fetchList } from "@/api/announcement.js";

export default {
  name: "HelloWorld",
  data() {
    return {
      handleList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      autoHeight: "0px",
    };
  },
  created() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      fetchList(this.currentPage,this.pageSize)
        .then((response) => {
          this.handleList = response.data.data;
          this.total = response.data.ev_rows
          // let Base64 = require("js-base64").Base64;
          // if (this.handleList != null) {
          //   this.handleList.forEach(function (currentValue, index, arr) {
          //     if (btoa(atob(currentValue.notic)) == currentValue.notic) {
          //       currentValue.notic = Base64.decode(currentValue.notic);
          //     }
          //   });
          // }
        })
        .then((response) => {
          let hasScroll =
            document.body.scrollHeight + 72 >
            (window.innerHeight || document.documentElement.clientHeight);

          if (!hasScroll) {
            //  页面没有滚动条时，内容不够高，需要加一个空白增加高度
            let h =
              "calc(100vh - 58px - 72px -  " +
              window.getComputedStyle(this.$refs.cnt).height +
              ") ";
            this.autoHeight = h;
          } else {
            this.autoHeight = "0px";
          }
        });
    },
    // handleSizeChange(val) {
    //   this.pageSize = val;
    // },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    },
  },
};
</script>
<style scoped>
.container {
  background: rgb(243, 243, 243);
  padding-bottom: 30px;
}
.banner {
  width: 100%;
  height: 300px;
  margin-bottom: 30px;
}

.shadow-down {
  filter: progid:DXImageTransform.Microsoft.Shadow(color=#000000,direction=120,strength=10); /*ie*/
  -moz-box-shadow: 1px 1px 10px #cacaca; /*firefox*/
  -webkit-box-shadow: 1px 1px 10px #cacaca; /*safari或chrome*/
  /* box-shadow:1px 1px 10px #cacaca; */ /*opera或ie9*/
}

/* .el-table::before {
  height: 0;
} */

.lk {
  color: #303133;
  text-decoration: none;
}
.table {
  width: 1000px;
  margin: 0 auto;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/Announcement/index.vue